// extracted by mini-css-extract-plugin
export default {"block":"ko","image":"lo","item":"mo","error":"no"};